
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 8.25a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zM9.75 12a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.404 4.14c-.611-2.52-4.196-2.52-4.808 0a.974.974 0 01-1.452.602c-2.216-1.349-4.75 1.186-3.401 3.4a.975.975 0 01-.603 1.454c-2.52.611-2.52 4.197 0 4.808a.974.974 0 01.601 1.453c-1.348 2.215 1.187 4.75 3.401 3.4a.975.975 0 011.454.603c.611 2.52 4.197 2.52 4.808 0a.974.974 0 011.453-.601c2.215 1.348 4.75-1.187 3.4-3.401a.976.976 0 01.603-1.454c2.52-.611 2.52-4.197 0-4.808a.974.974 0 01-.601-1.453c1.348-2.215-1.187-4.75-3.401-3.4a.975.975 0 01-1.454-.603zm-3.35.354c.24-.992 1.652-.992 1.892 0a2.474 2.474 0 003.692 1.53c.872-.531 1.87.466 1.34 1.339a2.473 2.473 0 001.528 3.69c.992.241.992 1.652 0 1.893a2.474 2.474 0 00-1.53 3.692c.532.872-.466 1.87-1.339 1.34a2.474 2.474 0 00-3.69 1.528c-.241.991-1.652.992-1.893 0a2.475 2.475 0 00-3.692-1.53c-.872.531-1.87-.466-1.34-1.339a2.474 2.474 0 00-1.528-3.69c-.992-.241-.992-1.652 0-1.893a2.475 2.475 0 001.53-3.692c-.531-.872.466-1.87 1.339-1.34 1.43.873 3.295.1 3.69-1.528z"}})])
          )
        }
      }
    